import React from 'react';
import {t} from '@lingui/core/macro';

import FiltersModal from '../FiltersModal/FiltersModal';

export interface IFiltersFormComponentProps {
    onClose: () => void,
}

interface IListFiltersModalProps {
    open: boolean,
    handleClose: () => void,
    Form: React.ComponentType<IFiltersFormComponentProps>,
}

const ListFiltersModal: React.FC<IListFiltersModalProps> = ({open, handleClose, Form}) => (
    <FiltersModal header={t`Фильтры`} open={open} handleClose={handleClose}>
        <Form onClose={handleClose}/>
    </FiltersModal>
);

export default ListFiltersModal;
